<template>
  <v-dialog
    :value="value"
    @input="$emit('input')"
    max-width="500px"
    persistent
    content-class="ims-standard-dialog"
  >
    <v-card class="ims-modal-card">
      <v-card-title class="title ims-modal-header">
        <span>Release Campaign to Admin</span>
        <v-spacer></v-spacer>
        <v-btn icon color="secondary" aria-label="Close" title="Close" @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="body-2 ims-modal-body" style="padding-top:30px">
        <div>
          <label>Please schedule a call with your respective AM to finalise the brief and provide a summary on the following next steps:
            <br>What are you getting out of this campaign brief and type of rejections/challenges or stucks you foresee from the creators</label>
          <v-textarea
            dense
            v-model="updateData.remarks"
            type="text"
            placeholder=""
            outlined
            @input="$v.updateData.remarks.$touch()"
            :error-messages="$v.updateData.remarks.$error && `Remarks is required.`"
            @blur="$v.updateData.remarks.$touch()"
          ></v-textarea>
        </div>
        <div>
          <label>Deadline</label>
          <v-menu
            v-model="deadlineCal"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="updateData.deadline"
                @input="$v.updateData.deadline.$touch()"
                :error-messages="$v.updateData.deadline.$error && `Deadline is required.`"
                @blur="$v.updateData.deadline.$touch()"
                append-icon="event"
                outlined
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              type="date"
              v-model="updateData.deadline"
              @input="deadlineCal = false"
            ></v-date-picker>
          </v-menu>
        </div>
      </v-card-text>
      <v-card-actions class="ims-modal-actions">
        <v-btn color="secondary" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save()" :disabled="$v.updateData.$invalid">Release to Admin</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
// import userAPIs from '../User/userAPIs';
// import config from '@/config';
import moment from 'moment'
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
export default {
  name: 'ReleaseToCcModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    campaign: Object
  },
  validations: {
    updateData: {
      deadline: { required },
      remarks: { required }
    }
  },
  data () {
    return {
      deadlineCal: false,
      isLoading: false,
      updateData: {
        deadline: '',
        remarks: ''
      }
    }
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      campaignUpdated: state => state.campaign.campaignUpdated
    }),
    currentUserID: function() {
      return this.$store.state.user.id;
    }
  },
  watch: {
    value: function(newValue) {
      this.updateData = {
        deadline: '',
        remarks: ''
      }
    }
  },
  methods: {
    async save() {
      this.isLoading = true
      this.updateData.createdAt = moment().toISOString()
      this.updateData.userID = this.currentUserID
      let saveData = Object.assign({}, {
        id: this.campaign.id,
        CCInputs: this.updateData,
        releasedToAdmin: true
      })
      await this.$store.dispatch('campaign/updateCampaignByIds', [saveData])
      this.isLoading = false
      if (this.campaignUpdated) {
        this.$swal({
          text: 'Successfully Released to Admin.',
          type: 'success'
        })
        await this.$store.dispatch('campaign/sendCampaignReleaseEmailToAdmin', {
          id: this.campaign.id
        })
        this.$emit('saved', this.campaign.id)
        this.close()
      } else {
        this.$swal({
          text: 'Error Release to Admin!',
          type: 'error'
        })
      }
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// ReleaseToAdminModal.vue?5786d3eb